import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNReport } from 'src/app/models/cnreport';
import { PatientService } from 'src/app/services/patient.service';
import { ReportService } from 'src/app/services/report.service';
import { ReportTableComponent } from '../report-table/report-table.component';

declare var Ext: any;

@ManageType('ReportPanelComponent')
@Component({
  selector: 'app-report-panel',
  templateUrl: './report-panel.component.html',
  styleUrls: ['./report-panel.component.scss']
})
export class ReportPanelComponent implements OnInit {

  public reports: CNReport[] = [];
  @ViewChild('reporttable', { static: true }) reportTable: ReportTableComponent;

  constructor(private patient: PatientService, private ngZone: NgZone,
              private reportservice: ReportService) { }

  ngOnInit(): void {
    this.reportservice.data.subscribe(data => {
      this.reports = data;
    });
    this.reportservice.clear.subscribe(flag => {
      this.reports = [];
      this.reportTable.clear();
    });
  }

  newReport() {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        // Open old report interface
        const documentWindow = new Ext.CNDocumentWindow({
          patientid: this.patient.patient.id
        });
        documentWindow.on('documentSaved', () => {
          console.log('document saved');
          setTimeout(() => {
            this.reload();
          });
        });
        documentWindow.show();
      });
    });
  }

  reload() {
    this.ngZone.run(() => {
      this.reportservice.load();
    });
  }
}
